/** Read a colour token defined on :root in index.css, for APIs that need a literal colour (canvas, QR). */
export function themeColor(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim();
}
